import { NewsItemType } from 'app/modules/admin/features/settings/appearance/news/types'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React, { useMemo, useState } from 'react'
import { NewsItem } from './news-item'
import Button from 'app/modules/shared/components/button'
import { Carousel } from 'react-bootstrap'
import { PageSelect } from 'app/modules/shared/components/pager/page-select'
import { useResponsive } from 'app/modules/shared/hooks/use-responsive'

export function News({ items }: { items: NewsItemType[] }) {
  const { _t } = useTypedTranslation()
  const [page, setPage] = useState(1)
  const { batch } = useResponsive(
    [
      { maxWidth: 576, batch: 1 },
      { maxWidth: 768, batch: 2 },
    ],
    { batch: 3 }
  )

  const batchedNews = useMemo(() => {
    return Array.from({ length: Math.ceil(items.length / batch) }).map((_, index) =>
      items.slice(index * batch, index * batch + batch)
    )
  }, [items, batch])

  return (
    <>
      <h2 className="h3 mb-0" style={{ marginTop: '64px' }}>
        {_t('latest-news')}
      </h2>

      <Carousel interval={null} controls={false} indicators={false} className="news-carousel" activeIndex={page - 1}>
        {batchedNews.map((batch, idx) => (
          <Carousel.Item key={idx}>
            <div className="row g-6 align-items-stretch">
              {batch.map((item) => (
                <NewsItem newsItem={item} key={item.order} />
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      <div className="pager-container w-100">
        <a
          id="home-page-news-x-link"
          className="btn btn-primary"
          href="https://x.com/filescan_itsec"
          target="_blank"
          rel="noreferrer nofollow"
        >
          {_t('go-to-x-page')}
        </a>

        {batchedNews.length > 1 && (
          <PageSelect page={page} totalPages={batchedNews.length} onChange={setPage} mode="compact" />
        )}
      </div>
    </>
  )
}
